/**
 * @package   ScandiPWA\GtmGraphQl
 * @author    Abdelrahman Hady <abdelrahman.hady@scandiweb.com>
 * @copyright Copyright (c) 2023 Scandiweb, Inc (https://scandiweb.com)
 * @license   http://opensource.org/licenses/OSL-3.0 The Open Software License 3.0 (OSL-3.0)
 */

import Event, { EVENT_GTM_ADD_TO_WISHLIST_GA4 } from '../../../util/Event';
import ProductHelper from '../GA4_utils';
import { NOT_APPLICABLE } from '../GA4_utils/Product';
import BaseEventEvent from './BaseEvent.event';

export const CHECKOUT_EVENT_DELAY = 1100;
export const SPAM_PROTECTION_DELAY = 1000;

/**
 * Add item to wishlist
 *
 * @namespace Gtm/Component/GoogleTagManager/GA4_events/AddToWishlist/Event */
export class AddToWishlistEvent extends BaseEventEvent {
    /**
     * Event fire delay
     *
     * @type {number}
     */
    eventHandleDelay = CHECKOUT_EVENT_DELAY;

    /**
     * Bind
     */
    bindEvent() {
        Event.observer(EVENT_GTM_ADD_TO_WISHLIST_GA4, (data) => {
            this.handle(data);
        });
    }

    /**
     * Handle
     */
    handler(data) {
        if (this.spamProtection(SPAM_PROTECTION_DELAY)) {
            return;
        }

        const { quantity } = data;
        const { productsInWishlist } = this.getAppState().WishlistReducer;
        const product = Object.values(productsInWishlist).pop();
        const category = this.getAppState().BreadcrumbsReducer.breadcrumbs[1].name;
        const {
            wishlist: {
                sku: variant_sku
            }
        } = product;
        const configurableVariantIndex = ProductHelper.getSelectedVariantIndex(product, variant_sku);

        this.pushEventData({
            currency: this.getCurrencyCode(),
            value: ProductHelper.getPrice(product, product.type_id),
            items: [
                {
                    ...ProductHelper.getProductData({ ...product, configurableVariantIndex }, category),
                    quantity: quantity || NOT_APPLICABLE,
                    item_variant: variant_sku,
                    ...this.getItemListData(product)
                }
            ]
        });
    }
}

export default AddToWishlistEvent;
